<template>
  <div id="click-box" class="tw-relative tw-w-[421px] tw-px-[12px]">
    <div
      class="tw-text-[#211F58] tw-text-[22px] tw-font-semibold tw-text-center tw-leading-[100%] tw-pb-[20px]"
    >
      {{ getComponentUiText("app-dashboard-cyber-health-no-data-title-1") }}
    </div>
    <div
      class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[normal] tw-text-center"
    >
      {{
        isNoData
          ? getComponentUiText("app-dashboard-cyber-health-no-data-note-1")
          : getComponentUiText("app-dashboard-cyber-health-no-action-note-1")
      }}
    </div>
    <div class="tw-text-center">
      <b-button
        v-if="props.isNoData"
        variant="primary"
        class="!tw-border-0 button-verify tw-bg-[#387DFF] tw-mt-[40px] tw-w-fit tw-py-[8px] tw-px-[20px] tw-text-[13px] tw-font-medium tw-rounded-[27px]"
        @click="rejectAssessment"
      >
        {{ getComponentUiText("app-assess-recommendations-no-data-button-1") }}
      </b-button>
      <b-button
        v-if="!props.isNoData"
        variant="primary"
        class="!tw-border-0 tw-leading-[normal] button-verify tw-bg-[#387DFF] tw-mt-[40px] tw-w-fit tw-py-[8px] tw-px-[20px] tw-text-[13px] tw-font-medium tw-rounded-[27px]"
        @click="rejectRecommendation"
      >
        {{
          getComponentUiText(
            "app-dashboard-cyber-health-no-action-blue-button-1",
          )
        }}
      </b-button>
      <b-button
        v-if="!props.isNoData"
        variant="primary"
        class="!tw-border-2 tw-leading-[normal] button-verify tw-bg-[transparent] tw-shadow-none tw-mt-[15px] tw-w-fit tw-py-[8px] tw-px-[20px] tw-text-[#387DFF] tw-text-[13px] tw-font-medium tw-rounded-[27px]"
        @click="emit('update-path')"
      >
        {{
          getComponentUiText(
            "app-dashboard-cyber-health-no-action-white-button-1",
          )
        }}
      </b-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import router from "@/router";
import store from "@/store";

const props = defineProps({
  isNoData: {
    type: Boolean,
    required: true,
  },
  idChecklist: {
    type: Number,
    default: 0,
    required: false,
  },
});

const emit = defineEmits(["update-path"]);

const rejectAssessment = () => {
  store.dispatch("Navigation/setActiveHierarchy", [
    getComponentUiText("app-menu-submenu-assess-assessments-1"),
    "",
    "",
    "",
  ]);
  store.dispatch("Navigation/setPrimaryMenuIndex", 2);
  router.push({
    name: "Assessment",
    query: {
      param: "OpenModalAssessment",
    },
  });
};

const rejectRecommendation = () => {
  store.dispatch("Navigation/setActiveHierarchy", [
    getComponentUiText("app-menu-submenu-assess-recommendations-1"),
    "",
    "",
    "",
  ]);
  store.dispatch("Navigation/setPrimaryMenuIndex", 3);
  router.push({
    path: "/assess/roadmap",
    query: {
      id: props.idChecklist,
    },
  });
};
</script>
